import React from "react";
import banner from "../../../Assets/images/BannerImages/scod.png";
import website from "../../../Assets/images/website.png";
import hf from "../../../Assets/images/hf.png";
import Banner from "../../../Components/Common/Banner";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";

const Scod = () => {
    return (
        <React.Fragment>
            <Banner bgimage={banner} pageName="SCOD(SPECIALITY CONSULTANT ON DEMAND)" visible={false} breadcrummbs="Home / Services / Scod " />

            <div className="lg:px-20 md:px-10 px-5 py-10 tracking-wide">
                <div>
                    <div className="flex lg:flex-row flex-col justify-center items-center gap-12">
                        <div className="flex flex-col gap-6 lg:w-[60%] w-full">
                            <h1 className="text-[#5e5e5e] font-bold text-[24px] text-justify">
                                HEEL THE BUSINESS WITH {""}
                                <span className="text-[#efae59]">QUALIFIED SERVICES.</span>
                            </h1>

                            <p className="text-justify font-bold text-[#5e5e5e]">
                                Manage the way you work on your enterprise - Hoist your
                                performance to the next level.
                            </p>

                            <p className="text-justify">
                                The Specialized Consultants On-Demand (SCOD) team of Techmentee
                                consists of the IT Staff consulting their services for many
                                leading fortune 500 companies. Tackling the challenges that stop
                                the growth, Techmentee is the best IT Training and placement
                                consultancy in Atlanta, GA and USA besides offering unique and
                                innovative solutions which are ideal and, on the other hand,
                                consistent and reliable by installing a vendor management system
                                for our clients' sourcing needs.
                            </p>

                            <p className="text-justify font-bold text-[#5e5e5e]">
                                Techmentee has been the leading multinational IT consulting
                                company addressing the dynamic needs of enterprises. Connect
                                with our TECH's SCOD team specialized in guaranteed advanced
                                resources supported by our TECH's Career Counseling and
                                Recruitment Services (CCRS) division that continuously recruits
                                the best consultants.
                            </p>
                        </div>
                        <div className="lg:w-[40%] w-full">
                            <img src={website} alt="ba" />
                        </div>
                    </div>
                </div>

                <div>
                    <div>
                        <div className="flex lg:flex-row flex-col gap-12">
                            <div className="lg:w-[40%] w-full">
                                <img src={hf} alt="hf" />
                            </div>
                            <div className="lg:w-[60%] w-full flex flex-col gap-6">
                                <h1 className="text-[#7c96bd] font-bold text-[24px] text-justify">
                                    HALLMARKS {""}
                                    <span className="text-[#efae59]">OF SCOD</span>
                                </h1>
                                <p className="text-justify tracking-wider">
                                    At Techmentee, we leverage the strategic IT roadmap that
                                    suits your business needs, align our tactics with your ideal
                                    objectives and consider the critical importance businesses
                                    behold for the futuristic development. Striving to be the best
                                    staffing agency Atlanta, GA, US, our CCRS division selects the
                                    right candidate before deploying them at any of our clients'
                                    projects. Techmentee TECH understands that the technical
                                    skill of our professionals is critical; hence we strive to
                                    make deliverability 100%.
                                </p>

                                <p className="text-justify text-[18px] text-[#5e5e5e] font-semibold tracking-wide">
                                    With innovative technological solutions, we hand in supreme
                                    trademarks for better enterprise programming while
                                    acknowledging the best we can without wasting your time and
                                    resources. Seems exciting, doesn't it?
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-6">
                    <GetInTouchUs />
                </div>

            </div>


        </React.Fragment>
    );
};

export default Scod;
